import React from "react";
import {longColour, shortColour} from "../../../style/styleConsts";
import styled from "styled-components";

const directionColourMapping = {
    SHORT: shortColour,
    LONG: longColour
};

export const DirectionColumn = styled.div`
    color: ${props => props.color};
    letter-spacing: ${props => props.letterSpacing};
    font-size: 11px;
`;

const DirectionCell = styled(DirectionColumn)`
    font-size: 12px;
`;

export const Direction = ({direction}) => {
    const letterSpacing = direction === "LONG" ? "1.7px" : "inherit";

    return <DirectionCell color={directionColourMapping[direction]}
                          letterSpacing={letterSpacing}
                          className="t-direction">
        {direction}
    </DirectionCell>;
};